import API from "../api/api";

const config = (token) => {
  return {
    headers: {
      "Content-type": "application/json",

      "X-Frame-Options": "DENY",
      "Content-Security-Policy": "style-src 'self'",
      Authorization: `Bearer ${token}`,
    },
  };
};


export const getMediaList = async (type,filters) => {
  // let token = localStorage.getItem("access_token");

  const response = await API.get(
    `get-media-list/${type}?reason=${filters.reason}&content_type=${filters.mediaType}`
    // config(token)
  )
    .then((data) => {
      return data;
    })
    .catch((err) => {
      return err;
    });
  return response;
};